import React from 'react'
import { useLocation } from 'react-router-dom';

interface ContentAlertModelProps {
    message: string;
    onClose: () => void;
    navigateFromLead: () => void;
    navigateFromOffers: () => void;
    navigatePath: string;

}

const ContentAlertModel: React.FC<ContentAlertModelProps> = ({ message, onClose, navigateFromLead, navigateFromOffers,navigatePath }) => {
    const location = useLocation();

    return (
        <>
            <h2>התראה</h2>
            <p style={{ color: 'red', fontSize: 20 }}> {message}</p>
            
            {location.pathname == '/Leads' ? (
                <button onClick={navigateFromLead} style={{
                    margin: '10px',
                    padding: '10px 20px',
                    backgroundColor: '#007BFF',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}>
                    {navigatePath === 'simulator' ? 'לסימולטור' : 'מעבר לליד'}
                </button>
            ) : (

                <button onClick={navigateFromOffers} style={{
                    margin: '10px',
                    padding: '10px 20px',
                    backgroundColor: '#007BFF',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}>
                    {navigatePath === 'simulator' ? 'לסימולטור' : 'מעבר לליד'}
                </button>
            )}
            <button onClick={onClose} style={{
                margin: '10px',
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
            }}>
                ביטול
            </button>
        </>
    )
}

export default ContentAlertModel